import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { authApi, AuthResponse } from "redux/services/auth";
import env from "env";

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  expiresIn: number | null;
};

const INITIAL_STATE: AuthState = {
  accessToken: null,
  refreshToken: null,
  expiresIn: null,
};

export const refreshToken = createAsyncThunk<AuthResponse>(
  "auth/refreshToken",
  async (_, { getState }: any) => {
    const { refreshToken } = getState().auth;
    const response = await fetch(
      `${env.api.baseUrl.tokenBaseUrl}oauth2/token`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${btoa(
            `${env.api.clientId}:${env.api.clientSecret}`
          )}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: (function () {
          const formBody = [
            { key: "refresh_token", value: refreshToken as string },
            { key: "grant_type", value: "refresh_token" },
          ]
            .map(
              (n) =>
                encodeURIComponent(n.key) + "=" + encodeURIComponent(n.value)
            )
            .join("&");
          return formBody;
        })(),
      }
    );
    const content = await response.json();
    return content;
  }
);

export const setTokens = createAction<AuthResponse>("auth/setTokens");

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    logout: () => INITIAL_STATE,
    setTokens: (state, { payload }) => {
      state.accessToken = payload.access_token;
      state.refreshToken = payload.refresh_token;
      state.expiresIn = payload.expires_in;
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(refreshToken.fulfilled, (state, { payload }) => {
      //   state.accessToken = payload.access_token;
      //   state.refreshToken = payload.refresh_token;
      //   state.expiresIn = payload.expires_in;
      // })
      .addMatcher(
        authApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          state.accessToken = payload.access_token;
          state.refreshToken = payload.refresh_token;
          state.expiresIn = payload.expires_in;
        }
      );
  },
});

export default authSlice.reducer;
export const { logout } = authSlice.actions;

export const selectAuth = (state: {auth: AuthState}) => state.auth;
